import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=67335ac5&scoped=true&"
import script from "./breadCrumb.vue?vue&type=script&lang=js&"
export * from "./breadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=67335ac5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67335ac5",
  null
  
)

export default component.exports